import { RootState } from '../interfaces/redux.interface';

export const getAccessToken = (state: RootState): string | null | undefined => {
  return state?.accessToken;
};
